import { Component, OnInit, Inject, AfterViewChecked } from '@angular/core';
import { Chart } from 'chart.js';
import { PlatformApiService } from './services/platform-api.service';
import { SessionService } from './services/session.service';
import { ThemeManagerService } from './services/theme-manager.service';
import { DomSanitizer } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { MatIconRegistry } from '@angular/material/icon';
import { LoggerService } from './services/logger.service';

require('json.date-extensions');
require('es6-promise').polyfill();
require('isomorphic-fetch');
require('chart.piecelabel.js');

@Component({
  selector: 'app-root',
  template: `
    <div class="app-div {{_themeManager.getThemeClass()}}">
      <div class="text-primary" style="display:none"></div>
      <div class="text-accent" style="display:none"></div>
      <div class="text-warn" style="display:none"></div>
    <router-outlet></router-outlet></div>
  `,
  styles: [`
  .app-div {
    margin: 0;
    height: 100%;
  }`]
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'app';

  constructor(@Inject(DOCUMENT) private document: any, private _loggerService: LoggerService, private _platformApi: PlatformApiService, private _domSanitizer: DomSanitizer, private _matIconRegistry: MatIconRegistry, public _themeManager: ThemeManagerService) {
    SessionService.initialize(this._platformApi, this._loggerService).subscribe();
  }

  ngOnInit() {
    console.log('Setting theme based on url', document.location.hostname);
    if (document.location.hostname.toLowerCase().includes('riskrats')) {
      this._themeManager.setThemeClass('riskrats-theme');
    } else if (document.location.hostname.toLowerCase().includes('sentrian')) {
      this._themeManager.setThemeClass('sentrian-theme');
    } else {
      this._themeManager.setThemeClass('connectwise-theme');
    }

    // Override the JSON parser to automatically convert ISO-8601 strings to Javascript Date objects
    (JSON as any).useDateParser();

    // Chartjs plugin that allows the background of a chart to be set to a gradient color
    Chart.pluginService.register({
      beforeDraw (chart, easing) {
        if ((chart.config.options as any).chartArea && ((chart.config.options as any).chartArea.backgroundGradientPoints || (chart.config.options as any).chartArea.backgroundSolidColor)) {
          const ctx = chart.ctx;
          const chartArea = chart.chartArea;

          ctx.save();

          let colorObj;

          if ((chart.config.options as any).chartArea.backgroundGradientPoints) {
            colorObj = ctx.createLinearGradient(chartArea.left, chartArea.bottom - chartArea.top, chartArea.right - chartArea.left, chartArea.top);

            // Add colors
            for (const grad of (chart.config.options as any).chartArea.backgroundGradientPoints) {
              colorObj.addColorStop(grad.position, grad.color);
            }
          } else {
            colorObj = (chart.config.options as any).chartArea.backgroundSolidColor;
          }

          ctx.fillStyle = colorObj;
          ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
          ctx.restore();
        }
      }
    });

    // Chart.pluginService.register({
    //   beforeRender: function (chart) {
    //     if (chart.config.options.showAllTooltips) {
    //     chart.pluginTooltips = []; chart.config.data.datasets.forEach(function (dataset, i) { chart.getDatasetMeta(i).data.forEach(function (sector, j) { chart.pluginTooltips.push(new Chart.Tooltip({ _chart: chart.chart, _chartInstance: chart, _data: chart.data, _options: chart.options.tooltips, _active: [sector] }, chart)); }); });
    //       // turn off normal tooltips
    //       chart.options.tooltips.enabled = false;
    //     }
    //   }, afterDraw: function (chart, easing) {
    //     if (chart.config.options.showAllTooltips) {
    //       // we don't want the permanent tooltips to animate, so don't do anything till the animation runs atleast once
    //       if (!chart.allTooltipsOnce) { if (easing !== 1) return; chart.allTooltipsOnce = true; } chart.options.tooltips.enabled = true; Chart.helpers.each(chart.pluginTooltips, function (tooltip) {
    //         tooltip.initialize(); tooltip.update();
    //         // we don't actually need this since we are not animating tooltips
    //         tooltip.pivot(); tooltip.transition(easing).draw();
    //       }); chart.options.tooltips.enabled = false;
    //     }
    //   }
    // });

    this._matIconRegistry.addSvgIconInNamespace('cw', 'companies', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/company.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'sales', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/sales.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'settings', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/settings.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'owl', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/cw-owl-icon.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'resend_email', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/resend-email.svg'));

    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_add', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Add.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_collapseup', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_CollapseUp.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_edit', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Edit.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_expanddown', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_ExpandDown.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_first', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_First.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_last', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Last.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_next', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Next.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_previous', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Previous.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_refresh', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Refresh.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_screenshot', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Screenshot.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_start', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Start.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'action_toggle_graph', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Action_Toggle_Graph.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'application_configuration', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Application_Configuration.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'application_newnotification', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Application_NewNotification.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'application_notification', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Application_Notification.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'application_appcues', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Application_Appcues.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'Application_Recent', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Application_Recent.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'default_avatar', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Default_Avatar.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'flag_enabled', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Flag_Enabled.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'flag_risk', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/flag_risk.svg'));
    this._matIconRegistry.addSvgIconInNamespace('cw', 'menu_companies', this._domSanitizer.bypassSecurityTrustResourceUrl('/assets/icons/Menu_Companies.svg'));
  }

  ngAfterViewChecked() {
    this._themeManager.updateThemeColors();
  }
}
